import { render, staticRenderFns } from "./usAddressConfirmation.vue?vue&type=template&id=60902968&scoped=true"
import script from "./usAddressConfirmation.vue?vue&type=script&lang=js"
export * from "./usAddressConfirmation.vue?vue&type=script&lang=js"
import style0 from "./usAddressConfirmation.vue?vue&type=style&index=0&id=60902968&prod&lang=less&scoped=true"
import style1 from "./usAddressConfirmation.vue?vue&type=style&index=1&id=60902968&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60902968",
  null
  
)

export default component.exports